import {
    fetchCurrentUser as _fetchCurrentUser,
    fetchArchiveLocations as _fetchArchiveLocations,
    fetchMyArchiveLocations as _fetchMyArchiveLocations,
    fetchMediaList as _fetchMediaList,
    deleteMedia as _deleteMedia,
} from "../../../utils/api";

// User //
// 現在のユーザー情報を取得
export const fetchCurrentUser = () => _fetchCurrentUser();

// ArchiveLocation //
// 一般ユーザー用：自分のロケーションのみ取得
export const fetchMyArchiveLocations = (projectId) =>
    _fetchMyArchiveLocations(projectId);

// 管理者など：すべてのロケーションを取得
export const fetchArchiveLocations = (projectId) =>
    _fetchArchiveLocations(projectId);

// Media //
// 特定ロケーションに紐づくメディア一覧を取得
export const fetchMediaList = (locationId) =>
    _fetchMediaList(locationId);

// メディアを削除
export const deleteMedia = (mediaId) =>
    _deleteMedia(mediaId);

